import * as React from 'react';
import BuilderFooter from 'components/BuilderFooter';
import Button, {ButtonVariant} from 'components/Button';

/**
 * The footer of the task progress.
 * @return {React.ReactElement}
 * @constructor
 */
export default function Footer(): React.ReactElement {
  return (
    <BuilderFooter>
      <Button type="button" variant={ButtonVariant.Primary}>
        Отправить на проверку
      </Button>
    </BuilderFooter>
  );
}
